module.exports = __webpack_public_path__ + "static/media/icons_Be CliN - Formation.44c7fa30.svg";